import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';

const PrivacyContent = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {
  const outerClasses = classNames(
    'testimonial section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'testimonial-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames('tiles-wrap', pushLeft && 'push-left');

  const sectionHeader = {
    title: 'Privacy Policy',
    paragraph: ''
  };

  return (
    <section {...props} className={outerClasses}>
      <div className='container'>
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className='center-content' />
          <p className='text-sm mb-32'>
            Keep Me Out as a free application which is ad-supported with an
            in-app purchases to remove ads from app. This Service is provided by
            Vikesh Dass at almost no cost and is intended for use as is. If you
            choose to use these Service, then you agree to the policies defined
            here. I will not use or share your information with anyone except as
            described in this Privacy Policy.
          </p>
          <h4 className='mt-0 mb-16'>Information Collection and Usage</h4>
          <p className='text-sm mb-32'>
            For a better experience while using these Service, Keep Me Out may
            require you to provide Read Contacts permission which will only be
            used to read user's contacts so as to allow user to make an
            emergency call while the Keep Me Out Service for device lock is
            running. Keep me out doesn't store these contacts anywhere
            permanently neither does it upload this information anywhere. Its
            strictly fetched while the application runs and is cleared as soon
            as the user exits the application Please note this app does use
            third party services that may collect information used to identify
            you.
          </p>
          <h4 className='mt-0 mb-16'>
            Third party Service Providers used in this application
          </h4>
          <p className='text-sm mb-32'>
            To assist in analyzing how the Services are being used and which
            areas need improvement : Google Analytics and Messaging. To serve
            advertisement : Google ads
          </p>
          <h4 className='mt-0 mb-16'>Changes to this Privacy Policy</h4>
          <p className='text-sm mb-32'>
            I may update these Privacy Policies from time to time. Thus, you are
            advised to review this page periodically for any changes. I will
            notify you of any changes by posting the new or updated Privacy
            Policies on this page. These changes are effective immediately,
            after they are posted on this page.
          </p>
          <h4 className='mt-0 mb-16'>Contact</h4>
          <p className='text-sm mb-32'>
            If you have any questions or comments about this Privacy Policy,
            please contact me at{' '}
            <a href='mailto:keepmeoutapp@gmail.com'>
              keepmeoutapp@gmail.com
            </a>{' '}
            or click 'Contact for support' within app options menu at the{' '}
            <a href='https://play.google.com/store/apps/details?id=vikesh.dass.keepmeout&hl=de&gl=US'>
              Keep Me Out Google Playstore page
            </a>
            .
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyContent;
